import React from "react";
import { Route, Routes } from "react-router-dom";
import FAQ from "../Pages/Support/FAQ";
import FAQList from "../Pages/Support/List";
import SettingsPage from "../Pages/Setting";

export const MiscRoutes = [
     { path:"/faq", element:<FAQ />},
     { path:"/ticket", element:<FAQList />},
     { path:"/settings", element:<SettingsPage />}
]
